import gql from 'graphql-tag';

import { AlbumFolderBaseDetails } from '../../../../../../../graphql/fragments/album-folder';
import { AlbumDetails } from '../../../../../../../graphql/fragments/album';

export const AlbumFolderForUpload = gql`
  query albumFolderForUpload($id: RecordID!) {
    albumFolder(id: $id) {
      id
      account {
        id
      }
      ...AlbumFolderBaseDetails
      parent {
        id
      }
      root {
        id
      }
      album_folder_hierarchy {
        records {
          id
          name
          individual_albums
          contributor_access {
            upload_access
          }
        }
      }
      children {
        album_folders(slice: { limit: 999 }) {
          records {
            id
            has_children
            ...AlbumFolderBaseDetails
          }
        }
        albums(slice: { limit: 999 }) {
          records {
            id
            has_children: has_album_photo_groups
            ...AlbumDetails
          }
        }
      }
    }
  }
  ${AlbumFolderBaseDetails}
  ${AlbumDetails}
`;

export const AlbumForUpload = gql`
  query albumForUpload($id: RecordID!) {
    album(id: $id) {
      id
      has_children: has_album_photo_groups
      album_photo_groups(slice: { limit: 999 }) {
        records {
          id
          name
          start_date
          end_date
          photos {
            total
          }
        }
      }
      ...AlbumDetails
    }
  }
  ${AlbumDetails}
`;
